import { render, staticRenderFns } from "./HuanjingjianceDetails.vue?vue&type=template&id=38f73aaa"
import script from "./HuanjingjianceDetails.vue?vue&type=script&lang=js"
export * from "./HuanjingjianceDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports